/*
 * @Author: changcheng
 * @LastEditTime: 2023-06-05 16:38:11
 */
export const ItemTitleTypeEnum = [
  { value: 1, name: "医士" },
  { value: 2, name: "医师" },
  { value: 3, name: "主治医师/主管医师" },
  { value: 4, name: "副主任医师" },
  { value: 5, name: "主任医师" },
  { value: 6, name: "中医士" },
  { value: 7, name: "中医师" },
  { value: 8, name: "主治中医师" },
  { value: 9, name: "副主任中医师" },
  { value: 10, name: "主任中医师" },
  { value: 11, name: "中西医结合医师" },
  { value: 12, name: "中西医结合主治医师" },
  { value: 13, name: "中西医结合副主任医师" },
  { value: 14, name: "中西医结合主任医师" },
];